// extracted by mini-css-extract-plugin
export default {"label":"Select_label__eT2w2","select":"Select_select__PD9ja"};